<template>
<div class="chapter">
<div class="inner_page">
<div class="Section">
<br/>
<br/>
<p class="MsoNormal"><b class="calibre2"><span class="calibre1">TEMPTED</span></b></p><br/>
<br/>
<p class="MsoNormal"><span class="calibre1">Robyn Carr</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Tempted01.vue?93dfca52